// extracted by mini-css-extract-plugin
module.exports = {"list":"UpdateSummary_list__-4YwR","details":"UpdateSummary_details__1D_cU"};